import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import CertImageSkeleton from '../assets/images/certificates/placeholder_certificate_skeleton.png';
import CertAchieverValidationsSkeletonImg from '../assets/images/certificates/placeholder_achiever_skeleton.png';
import CertNameSkeletonImg from '../assets/images/certificates/placeholder_certificate_name_skeleton.png';
import CertAlertSkeletonImg from '../assets/images/certificates/placeholder_alert_skeleton.png';
import CertValidationsSkeletonImg from '../assets/images/certificates/placeholder_validations_skeleton.png';
import CertLinksSkeletonImg from '../assets/images/certificates/placeholder_links_skeleton.png';

export default function CertificateSkeleton() {
    return (
        <Stack mt={5} pt={2}>
            <Grid container mt={5}>
                <img alt="skeleton" width={'100%'} src={CertNameSkeletonImg} />
            </Grid>

            <Grid container m={1} mt={2} sx={{ display: { xs: 'none' } }}>
                <img alt="skeleton" src={CertAlertSkeletonImg} />
            </Grid>

            <Grid container spacing={2} mt={1} mb={2}>
                <Grid size={{ md: 8, xs: 12 }} pb={2}>
                    <Stack direction="column" justifyContent="{center}" mb={2} alignItems={'center'}>
                        <img
                            alt="skeleton"
                            style={{ width: '100%', borderRadius: 12, elevation: 3 }}
                            src={CertImageSkeleton}
                        />
                        <div
                            style={{
                                elevation: 4,
                                position: 'absolute',
                                right: '12px',
                                top: '10px',
                            }}
                        ></div>
                        <CircularProgress
                            style={{
                                top: '50%',
                                position: 'absolute',
                                width: '60px',
                                left: '50%',
                                height: '60px',
                            }}
                        />
                    </Stack>
                    <Stack spacing={2}>
                        <img alt="skeleton" src={CertValidationsSkeletonImg} />
                        <img alt="skeleton" src={CertValidationsSkeletonImg} />
                    </Stack>
                </Grid>
                <Grid size={{ md: 4, xs: 12 }} mt={1.5}>
                    <Stack>
                        <img alt="skeleton" src={CertAchieverValidationsSkeletonImg} />
                    </Stack>
                    <Stack pt={2}>
                        <img alt="skeleton" src={CertLinksSkeletonImg} />
                    </Stack>
                </Grid>
            </Grid>
        </Stack>
    );
}
